export const types = {
    POST: 'POST_RECURSOSITEMS',
    PUT: 'UPDATE_RECURSOSITEMS',
    DELETE: 'DELETE_RECURSOSITEMS',
    RESET: 'RESET_RECURSOSITEMS',
    RELOAD: 'RELOAD_RECURSOSITEMS',
  };
  
 
  
 const RecursosItemsReducer = (state = [], action) => {
    switch (action.type) {
      case types.POST:
        
        return [
          ...state,
          { ...action.payload },
        ];

      case types.PUT:
        return state.map((child) => (child.id == action.payload.id ? action.payload : child));

      case types.DELETE:
        const newValues = [...state];
        
        const index = newValues.findIndex(
          (elem)=>{
            return elem.id==action.id;
          }
          );
        
        newValues.splice(index, 1);
        return newValues;

      case types.RELOAD:
          
        return action.payload;

      case types.RESET:
        return [];

      default:
        return state;
    }
  };

  export default RecursosItemsReducer;